import template from './service_assignment_rules.all.html';
import controller from './service_assignment_rules.all.controller';
import './service_assignment_rules.all.scss';

let ServiceAssignmentRulesAllComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default ServiceAssignmentRulesAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/service_assignment_rules/all/service_assignment_rules.all.component.js